// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-77be7a69] {\n  fill: #fff\n}\n.st66[data-v-77be7a69] {\n  fill: #e684e4\n}\n", ""]);
// Exports
module.exports = exports;
